export const financialUrl = {
    slugName: 'financeiro',
    title: 'Financeiro',
    beta: false,
    link: 'https://financeiro.agilize.com.br',
    icon: `<svg width="19" height="23" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 4.5H19.875C22.0841 4.5 23.875 6.29086 23.875 8.5V19.25C23.875 21.4591 22.0841 23.25 19.875 23.25H4.75C2.54086 23.25 0.75 21.4591 0.75 19.25V4.5Z"
        fill="#B69BE0"
      />
      <path d="M0.75 4.5C0.75 2.42893 2.42893 0.75 4.5 0.75H15.75C17.8211 0.75 19.5 2.42893 19.5 4.5H0.75Z" fill="#7A4DBF" />
      <circle cx="20.125" cy="13.875" r="1.875" fill="#7A4DBF" /> 
    </svg> `,
}

export const apps = [
  {
    slugName: "rh",
    title: "Recursos Humanos",
    beta: false,
    link: "https://rh.agilize.com.br",
    icon: `<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="5.5" r="5" fill="#7A4DBF" />
        <rect y="13.5" width="18" height="6" rx="3" fill="#B69BE0" />
      </svg>`,
  },
  {
    slugName: "contabil",
    title: "Contábil",
    beta: false,
    link: "https://app.agilize.com.br",
    icon: `<svg width="19" height="24" viewBox="0 0 19 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.25" y="0.75" width="18.125" height="22.5" rx="4" fill="#B69BE0" />
        <rect x="3.375" y="8.875" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="3.375" y="13.25" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="3.375" y="17.625" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="7.75" y="8.875" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="7.75" y="13.25" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="7.75" y="17.625" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="12.125" y="8.875" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="12.125" y="13.25" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
        <rect x="12.125" y="17.625" width="3.125" height="3.125" rx="1.5625" fill="#7A4DBF" />
      </svg>`,
  },
  {
    slugName: "apps",
    title: "Acesso às apps",
    beta: false,
    link: "",
    icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="7" height="7" rx="2" fill="#7A4DBF"/>
      <rect y="13" width="7" height="7" rx="2" fill="#7A4DBF"/>
      <rect x="13" width="7" height="7" rx="2" fill="#7A4DBF"/>
      <rect x="13" y="13" width="7" height="7" rx="2" fill="#7A4DBF"/>
      </svg>`,
  },
];
